/**
 * rows.js — snapshot → plain rows `{ id, ...data }`.
 *
 * Firestore hands back a brand-new object for EVERY doc on every snapshot, so one tick
 * on the board made all ~1,600 rows look changed and every memoized row re-rendered.
 * `rowTracker()` keeps the row object of each doc that didn't change since the last
 * snapshot (it reads `snap.docChanges()`), so screens can compare rows by identity.
 * One tracker per listener.
 */
export function rowTracker() {
  const rows = new Map();   // id → row
  const make = d => { const row = { id: d.id, ...d.data() }; rows.set(d.id, row); return row; };
  return (snap) => {
    if (typeof snap.docChanges !== 'function') return snap.docs.map(make);
    snap.docChanges().forEach(({ type, doc }) => {
      if (type === 'removed') rows.delete(doc.id);
      else make(doc);
    });
    return snap.docs.map(d => rows.get(d.id) || make(d));
  };
}
